import { IPseBanks } from 'recaudo-common';
import api from '../api';

export const getPseBanks = async () => {
  return await api.get<IPseBanks[]>('/incoming/pse/banks');
};
